import React from 'react';
import { Body1 } from '../Typography';
import { withStyles } from "tss-react/mui";
import styles from './styles';

const Label = (props) => (
    <Body1 component="label" className={props.classes.root}>
        {props.children} {props.required && <span className={props.classes.required}>*</span>}
    </Body1>
);

export default withStyles(Label, styles);